import { render, staticRenderFns } from "./NotificationCampaignDialog.vue?vue&type=template&id=55cf0891&scoped=true&lang=pug"
import script from "./NotificationCampaignDialog.vue?vue&type=script&lang=js"
export * from "./NotificationCampaignDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationCampaignDialog.vue?vue&type=style&index=0&id=55cf0891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf0891",
  null
  
)

export default component.exports